import React from 'react';
import { Container } from '@/components/ui/Container';
import { TASK_ATTACHMENT_TILE_OVERLAY_RADIUS } from '@hooks/projects/task/useTaskAttachmentTile';

export function FileAttachmentContainer({ visible, clickable, onClick, children }) {
    return (
        <Container
            $position="absolute"
            $display="flex"
            $alignItems="center"
            $justifyContent="center"
            style={{
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                borderRadius: TASK_ATTACHMENT_TILE_OVERLAY_RADIUS,
                background: 'rgba(0,0,0,0.35)',
                backdropFilter: 'blur(6px)',
                WebkitBackdropFilter: 'blur(6px)',
                cursor: clickable ? 'pointer' : 'default',
                opacity: visible ? 1 : 0,
                pointerEvents: visible ? 'auto' : 'none',
                transition: 'opacity 160ms ease',
            }}
            onClick={onClick}
        >
            {children}
        </Container>
    );
}

